import React, { useContext } from 'react';
import { getPriSecColors } from '@hydra/utils/colors';

interface PdfTemplateContext {
  externalLinks: boolean,
  customCriteria: Record<string, { customText: {}, enabled: boolean }>,
  applyCustomCriteria: boolean,
  pdfTheme: string,
  orientation: string,
  templateColors: {
    primary: string,
    secondary: string[]
  }
}

const PdfTemplateContext = React.createContext<PdfTemplateContext>({
  externalLinks: false,
  customCriteria: {},
  applyCustomCriteria: false,
  pdfTheme: 'classic',
  orientation: 'portrait',
  templateColors: getPriSecColors()
});

interface PdfTemplateProps extends PdfTemplateContext {
  children: React.ReactNode
}

export function PdfTemplateProvider ({
  externalLinks = false,
  customCriteria = {},
  applyCustomCriteria = false,
  pdfTheme = 'classic',
  orientation = 'portrait',
  templateColors = getPriSecColors(),
  children
}: PdfTemplateProps) {
  return (
    <PdfTemplateContext.Provider
      value={{
        externalLinks,
        customCriteria,
        applyCustomCriteria,
        pdfTheme,
        orientation,
        templateColors
      }}
    >
      {children}
    </PdfTemplateContext.Provider>
  );
}

export const usePdfTemplateContext = () => useContext(PdfTemplateContext);

export default PdfTemplateContext;
